import { connect } from 'react-redux';
import { compose, lifecycle, withState, withHandlers, withProps } from 'recompose';
import { injectIntl } from 'react-intl';

import { withEscHandler } from 'shared/hocs/modalWithEscHandler';
import { fetchConsentData, declineConsent } from 'modules/conference/actions/fetchConsentData';
import checkMobileDevice from 'shared/utils/checkMobileDevice';

import ModalAppointmentForwardingConsent from './ModalAppointmentForwardingConsent';

export default compose(
  withEscHandler,
  injectIntl,
  connect(null, { fetchConsentData, declineConsent }),
  withProps({
    isMobile: checkMobileDevice(),
  }),
  withState('consentData', 'setConsentMessages', { isPending: true, showSnackbar: true }),
  lifecycle({
    componentDidMount() {
      const { setConsentMessages, fetchConsentData, bodyValues: { appointmentId }, consentData } = this.props;
      fetchConsentData(appointmentId)
        .then(({ payload }) => {
          setConsentMessages({ ...consentData, ...payload, isPending: false });
        });
    },
    componentWillUnmount() {
      const { consentData: { declineMessage, showSnackbar } } = this.props;
      if (!showSnackbar) return;

      this.props.declineConsent(declineMessage);
    },
  }),
  withHandlers({
    onOk: ({ onOk, setConsentMessages }) => () => {
      setConsentMessages({ showSnackbar: false });
      setTimeout(() => onOk(), 100);
    },
  }),
)(ModalAppointmentForwardingConsent);
